/* eslint-disable prefer-arrow/prefer-arrow-functions */
/* eslint-disable space-before-function-paren */
/* eslint-disable @typescript-eslint/naming-convention */
import { AfterViewChecked, AfterViewInit, ApplicationRef, Component, ComponentFactory, ComponentFactoryResolver, Injector, OnInit, ViewEncapsulation } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Breadcrumb } from 'app/core/services/breadcrumb/breadcrumb.interface';
import { BreadcrumbService } from 'app/core/services/breadcrumb/breadcrumb.service';
import { LocalisationService } from 'app/core/services/localisation/zuper.localisation.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import * as L from 'leaflet';
import 'iso8601-js-period';
import * as timeDimension from '../../../../../custom_modules/leaflet-timedimension/leaflet.timedimension.src.js';
import * as R from 'leaflet-responsive-popup';
import { ActivatedRoute } from '@angular/router';
import { MapsService } from '../maps.service';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import moment, { Moment } from 'moment';
import { LocalStorageService } from 'app/core/services/localstorage.service';
import { TimesheetsService } from 'app/core/services/timesheets/timesheets.service';
import { TimeFormatPipe } from 'app/core/pipes/timeFormat.pipe';
import { JobPopupComponent } from '../map-layout/map-components/job-popup/job-popup.component';
import { MatCalendarCellClassFunction } from '@angular/material/datepicker';
import { BadgeOptions, badgeColorCode } from 'app/components/badge/badge.interface';
import { ZuperDialogService } from '@zuper/components/zuper-dialog/zuper-dialog.service';
import { NoHistoryComponent } from 'app/components/no-history/no-history.component';
import { CreateHotToastRef, HotToastService } from '@ngneat/hot-toast';

@Component({
  selector: 'app-map-history',
  templateUrl: './map-history.component.html',
  styleUrls: ['./map-history.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MapHistoryComponent implements OnInit, AfterViewChecked, AfterViewInit {

  breadcrumbData: Breadcrumb = {
    'moduleName': 'maps',
    'displayKey': 'text.maps',
    'moduleKey': 'MAPS',
    'redirectTo': '/maps',
    'breadcrumbItems': [
      {
        'displayKey': 'map.breadcrumb.location_history',
        'displayName': 'Loation History'
      }
    ],

};
  activeGeoCords: number[];
  map: any;
  tileLayer: string;
  currentTitleType: string = 'DEFAULT';
  userUid: string;
  currentLocation: any;
  timesheets: any[] = [];
  checkType: any = {
    'CHECK_IN' : 'PUNCH IN',
    'CHECK_OUT': 'PUNCH OUT'
  };
  jobGroupsMarker: any[];
  jobLayerGroup: any;
  currentDate: any;
  dateFormat: string;
  geoJSONTDLayer: any;
  timesheetGroupMarker: any[];
  timesheetLayerGroup: any = '';
  allJobs: any[] = [];
  openDrawer: boolean = false;
  today: any = moment();
  geoCordsNotFoundToastRef: CreateHotToastRef<any>;
  previewOptions: any = {
    position: 'right',
    type: 'summary',
    mode: 'over',
    hasBackDrop: false
  };

  private mapTileUrl: string = window['mapTileUrl'];
  private satelliteUrl: string = null;



  constructor(
    private _breadcrumbService: BreadcrumbService,
    private _title: Title,
    private _localisationService: LocalisationService,
    private _route: ActivatedRoute,
    private _mapsService: MapsService,
    private _dataCollectorService: DataCollectorService,
    private _localStorageService: LocalStorageService,
    private _timesheetService: TimesheetsService,
    private timeformat: TimeFormatPipe,
    private _resolve: ComponentFactoryResolver,
    private _injector: Injector,
    private _appRef: ApplicationRef,
    private _dialog: ZuperDialogService,
    private toastService: HotToastService,
    public utilityService: UtilityService,
  ) {
    this._breadcrumbService.count = '';
    this.satelliteUrl = this._mapsService.satelliteUrl
   }

   historyDateChange(event: any): void {
    this.getUserLocation();
   }

   dateClass: MatCalendarCellClassFunction<Date> = (cellDate, view) => {
    if ((moment(cellDate).date() === 1) &&
        (view === 'month')
       )
    {
       this.changeMonth(cellDate);
    };
    return '';
  };

  changeMonth(date: any): void {
    this.getTimesheetAvailability(date);
  }

  previewDataEventHandler(event: any): void {
    if (event.drawerClosed) {
      this.openDrawer = false;
    }
  }

  getJobStatusOptions(status: any): BadgeOptions {
    const badgeOption: BadgeOptions = {
      type: status?.status_name,
      color: status?.status_color || badgeColorCode[status?.status_type],
      displayName: status?.status_name,
      extraClass: 'capitalize'
    };
    return badgeOption;
  }

  getJobPriorityBadgeOptions(job): BadgeOptions{
    if(job?.job_priority){
      return {
        type: job.job_priority,
        displayKey: null,
        displayName: job.job_priority.toLowerCase(),
        extraClass: 'capitalize'
      };
    }
  }

  getTimesheetAvailability(date: Moment): void {
    const filter = {
      'from_date': date.startOf('month').format('YYYY-MM-DD'),
      'to_date': date.endOf('month').format('YYYY-MM-DD'),
      'user_uid': this.userUid
    };

    this._dataCollectorService.getData(this._timesheetService.historyAvailabilityUrl, filter)
      .subscribe((res: any) => {
        const allCellContent = document.querySelectorAll('.mat-calendar-body-cell-content');
        allCellContent.forEach((cell: any) => {
          const found = res?.data.findIndex((data: any) => (moment(data, 'YYYY-MM-DD').format('D') === cell.innerText));
          if(found > -1){
              cell.classList.add('route-available');
            }else{
              cell.classList.remove('route-available');
          }
        });
      });
  }


   setTileLayer(type: string, event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.map.removeLayer(this.tileLayer);
    this.currentTitleType = type;
    if(type === 'SATELLITE'){
      this.tileLayer = L.tileLayer(this.satelliteUrl, { styleId: 997, edgeBufferTiles: 5 }).addTo(this.map);
    }else if(type === 'DEFAULT') {
      this.tileLayer = L.tileLayer(this.mapTileUrl, { styleId: 997, edgeBufferTiles: 5 }).addTo(this.map);
    }

  }

  getRouteParam(): void {
    this._route.params.subscribe(
      (res: any) => {
        this.userUid = res?.user_uid;
        this.currentDate = moment(this._route.snapshot.queryParams?.date, 'YYYY-MM-DD');
        this.getUserLocation();
      }
    );
  }

  getUserLocation(): void {
    this._dataCollectorService.getData(this._mapsService.mapsAPi.getUserLocation,{
      user_uid: this.userUid,
      date: moment(this.currentDate).format('YYYY-MM-DD')
    }).subscribe((res: any) => {
      if(this.geoJSONTDLayer){
        this.map.removeLayer(this.geoJSONTDLayer);
        this.geoJSONTDLayer = '';
      }
      this.timesheetGroupMarker = [];
      if(this.timesheetLayerGroup){
        this.map.removeLayer(this.timesheetLayerGroup);
        this.timesheetLayerGroup = '';
      }
      this.currentLocation = res?.data;
      if(this.currentLocation?.locations?.length){
        const time = this.currentLocation?.locations.map((location: any) => location?.track_time);
        const battery = this.currentLocation?.locations.map((location: any) => location?.battery);
        const signal = this.currentLocation?.locations.map((location: any) => location?.signal_strength);
        const cords = [];
        this.currentLocation?.locations.forEach((location: any, i: number) => {
          cords[i] = [location?.longitude, location?.latitude];
        });
        const location_data = {
            'type' : 'Feature',
            'properties' : {
                'name' : 'User Location History',
                'times': time,
                'battery': battery,
                'signal': signal
            },
            'geometry' : {
                'type' : 'LineString',
                'coordinates' : cords
            }
        };
        setTimeout(()=>{
          this.addGeoJSONLayer(location_data);
        },500);
      }
      this.loadTimesheets();
      this.getJobs();
    });
  }

  loadTimesheets(): void {
    const params = {
      count : 100,
      page  : 1,
      date  : moment(this.currentDate).format('YYYY-MM-DD'),
      to_date : moment(this.currentDate).format('YYYY-MM-DD')
     };
    params['filter.user_uid'] = this.userUid;
    this._dataCollectorService.getData(this._timesheetService.timesheetsURL, params)
      .subscribe((res: any) => {
        this.timesheets = res?.data['timesheets'];

        if(this.timesheets?.length > 0) {
          if(this.timesheets[0]?.latitude && this.timesheets[0]?.longitude){
            this.map.setView([this.timesheets[0]?.latitude, this.timesheets[0]?.longitude], 16);
          }
          this.timesheets.forEach((t: any) => {
            let popup_template = '<div class=\'map_popup_box\'>';
                  popup_template += '<p>' + this.checkType[t.type_of_check] + ' AT ' + this.timeformat.transform(t.checked_time) + '</p>';

             const statusIcon = L.divIcon({
                 className: 'timesheet-marker ' + t.type_of_check +'-marker',
                 iconSize: [50, 50],
                 iconAnchor: [15, 42]
              });

              const popup = L.responsivePopup({ minWidth: 140, offset: [5,-35] }).setContent(popup_template);
              if(t && t.latitude && t.longitude){
                 this.timesheetGroupMarker.push(L.marker([t.latitude,t.longitude], {icon : statusIcon}).addTo(this.map).bindPopup(popup));
              }
          });
          this.timesheetLayerGroup = L.layerGroup(this.timesheetGroupMarker);
          this.map.addLayer(this.timesheetLayerGroup);
       }else if(this.currentLocation?.locations?.length === 0 && this.timesheets?.length === 0){
        this.openNoHistoryModal();
       }
      });
  }

  openNoHistoryModal(): void {
    const noHistoryModal = this._dialog.openCustom(NoHistoryComponent,{
      extraClass: 'no-history-dialog',
      data:{
        date: this.currentDate,
        userUid: this.userUid
      }
    });
    noHistoryModal.afterClosed().subscribe((res: any) => {
      if(res){
        this.currentDate = res;
        this.getUserLocation();
      }
    });
  }

  setJobView(address: any): void {
    if (this.geoCordsNotFoundToastRef?.close) {
      this.geoCordsNotFoundToastRef.close();
    }
    if (this.utilityService.isValidGeoCords(address?.geo_cordinates)) {
      this.map.setView(address?.geo_cordinates, 16);
    }
    else {
      this.geoCordsNotFoundToastRef = this.toastService.error(this.utilityService.getLocaleValue('customer.enforce_geocode.alert', 'Geo-location not found'));
    }
  }

  getJobs(): void {
    const filter = {
      'filter.assigned_to': this.userUid,
      'filter.from_date': moment(this.currentDate).format('YYYY-MM-DD'),
      'filter.to_date': moment(this.currentDate).format('YYYY-MM-DD'),
      'count': 50,
      'page': 1,
      'sort': 'ASC',
      'sort_by': 'scheduled_start_time'
    };
    this._dataCollectorService.getData(this._mapsService.mapsAPi.getJobs, filter)
      .subscribe((res: any) => {
        this.getJobLocationData(res?.data);
        this.allJobs = res?.data;
      });
  }

  getJobLocationData(res): void{
      this.jobGroupsMarker = [];
      if(this.jobLayerGroup){
        this.map.removeLayer(this.jobLayerGroup);
        this.jobLayerGroup = '';
      }
      if(res?.length > 0){
        res.forEach((data)=>{
          if(data?.customer_address?.geo_cordinates){
            this.getJobMarker(data);
          }
        });
      }
  }

  getJobMarker(data: any): void{

    //Initializing Icon
      const icon = L.divIcon({
        className: 'custom-div-icon',
        html: '<img style="width:100%" src="assets/images/svgs/job_map_marker.svg" alt="job marker icon">',
        iconSize: [40, 52],
        iconAnchor: [15, 42]
      });

      //Construct marker
      const markerPopup: any =  this.compilePopup(JobPopupComponent, (c) => {c.instance.data = data;});

      const popup = R.responsivePopup({ minWidth: 280, offset: [5,-35] }).setContent(markerPopup);

    //Creating marker and binding events
    const marker = L.marker(data.customer_address.geo_cordinates, {
          icon: icon
        }).bindPopup(popup);

    //Grouping markers
    this.jobGroupsMarker.push(marker);

    //Adding the group to map
    this.jobLayerGroup = L.layerGroup(this.jobGroupsMarker);
    this.map.addLayer(this.jobLayerGroup);
  }

  addGeoJSONLayer(data: any): void {

    const icon = L.divIcon({
        className:'custom-div-icon',
        html: this._mapsService.getEmployeeIcon(this.currentLocation?.user),
        iconSize: [30, 42],
        iconAnchor: [15, 42]
    });

    const geoJSONLayer = L.geoJSON(data, {
        pointToLayer: function (feature, latLng) {
            if (feature.properties.hasOwnProperty('last')) {
                return new L.Marker(latLng, {
                    icon: icon
                });
            }
            return L.circleMarker(latLng);
        }
    });
    this.geoJSONTDLayer = L.timeDimension.layer.geoJson(geoJSONLayer, {
        updateTimeDimension: true,
        duration: 'PT2M',
        updateTimeDimensionMode: 'replace',
        addlastPoint: true,
    });

    // Show both layers: the geoJSON layer to show the whole track
    // and the timedimension layer to show the movement of the user
    geoJSONLayer.addTo(this.map);
    setTimeout(()=>{
      this.geoJSONTDLayer.addTo(this.map);
    }, 500);
}

  ngOnInit(): void {
    const userPreference = this._localStorageService.getLocalStorage('user_preferences');
    this.dateFormat = this.utilityService.dateFormat;
    window['user_preferences'] = userPreference;
    this._breadcrumbService.count = '';
    this._localisationService.setDefaultLanguage();
    this._breadcrumbService.subject.next(this.breadcrumbData);
    this.getRouteParam();
  }

  ngAfterViewChecked(): void {
    this._title.setTitle(this.utilityService.getLocaleValue('zuper.title.maps_history','Zuper Pro - Maps History'));
  }

  ngAfterViewInit(): void {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((res)=>{
        if(res?.coords?.latitude && res?.coords?.longitude){
          this.activeGeoCords = [res.coords.latitude, res.coords.longitude];
          this.initMap(true);
        }
      },(err)=>{
        this.initMap(false);
      });
     }
  }

  private initMap(is_coords: boolean): void {
    let center; let zoom;
    if(is_coords){
      center = this.activeGeoCords;
      zoom = 11;
    }else{
      center = [ 40.6000135, -25.2314079 ];
      zoom = 3;
    }

    this.map = L.map('map', {
      center : center,
      zoom : zoom,
      zoomControl : false,
      attributionControl : false,
      timeDimensionControl: true,
      timeDimensionControlOptions: {
          timeSliderDragUpdate: true,
          loopButton: true,
          autoPlay: true,
          speedSlider:false,
          minSpeed:5,
          playerOptions: {
              transitionTime: 1000,
              loop: true
          },
      },
      timeDimension: true,
    });
    L.control.zoom({position:'bottomright'}).addTo(this.map);
    this.tileLayer = L.tileLayer(this.mapTileUrl, { styleId: 997, edgeBufferTiles: 5 }).addTo(this.map);
    // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
    timeDimension(this);
    setTimeout(function(this) {
      window.dispatchEvent(new Event('resize'));
    }, 500);

  }

  private compilePopup(component,onAttach): any {
    const compFactory: ComponentFactory<Component>  = this._resolve.resolveComponentFactory(component);
    const compRef = compFactory.create(this._injector);
    if (onAttach) {onAttach(compRef);}

    this._appRef.attachView(compRef.hostView);
    compRef.onDestroy(() => this._appRef.detachView(compRef.hostView));

    const div = document.createElement('div');
    div.appendChild(compRef.location.nativeElement);
    return div;
  }

}
